import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { assertSingleReactRuntime } from './lib/runtimeGuard';

assertSingleReactRuntime();

const root=document.getElementById('root');
if(!root)throw new Error('Xynysys root element was not found');
ReactDOM.createRoot(root).render(<App/>);
